import script from "./CourseAddToFavourites.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseAddToFavourites.vue?vue&type=script&setup=true&lang=js"

import "./CourseAddToFavourites.vue?vue&type=style&index=0&id=b654a6cc&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b654a6cc"]])

export default __exports__